import axios from 'axios'
export default {
  // ... 其他 actions
  async getCompanyInfo({ commit }) {
    try {
      const domain =window.location.hostname
      const res = await axios.get(`https://www.htsd.vip/prod-api/ht-tool/api/subCompany/get?domain=${domain}`)
      if(res.data.code === 200) {
        console.log(1111);
        commit('SET_COMPANY_INFO', res.data.data)
        document.title = res.data.data.companyFullName
      }
    } catch(err) {
      console.error('获取公司信息失败:', err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js